<script setup lang="ts">
import type { PropType } from 'vue';

defineProps({
  title: { type: String, required: true },
  answer: { type: String, required: true },
})

</script>
<template>
  <details class="group [&_summary::-webkit-details-marker]:hidden mb-4 border-b-2 border-gray-300" close>
    <summary class="flex cursor-pointer items-center justify-between gap-1.5 p-4 text-gray-900">
      <h2 class="font-medium text-xl">{{ title }}</h2>

      <svg class="size-5 shrink-0 transition duration-300 group-open:-rotate-180" xmlns="http://www.w3.org/2000/svg"
        fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </summary>

    <p class="mt-4 px-4 block pb-4 leading-relaxed text-gray-700">
      <!-- {{ answer }} -->
      <Markdown :content="answer" :faq-mode="true" />
    </p>
  </details>
</template>